// @ts-ignore
import * as cbor from 'cbor-web';
import { JSONObject } from '../models/file.models';
import { markerFrom } from '../components/panels-container/panels-container';

export const CBORLD_MIME_TYPE = 'application/cbor';
export const JSONLD_MIME_TYPE = 'application/ld+json';

export const isValidURL = (str: string): boolean => {
  const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return pattern.test(str);
}

export const getClearFileName = (fullName: string): string =>
  fullName.replace(/\.[^/.]+$/, "")
// export const cborToText = (cbor: Uint8Array): string =>
//   cbor.buffer.toString();
  // new TextDecoder().decode(cbor);
// const cborBinary = new TextEncoder().encode(cborText);
// export const cborToText = (cbor: Uint8Array): string =>
//   String.fromCharCode(...new Uint8Array(cbor));
export const cborToText = (cborBinary: Uint8Array): Promise<string> =>
  cbor.comment(cborBinary, { no_summary: true });
export const cborToHex = (cborBinary: Uint8Array): string =>
  Array.prototype.map.call(cborBinary, x => (`00${x.toString(16)}`).slice(-2)).join('');
export const textToCbor = (cborText: string): Uint8Array =>
  Uint8Array.from([...cborText].map(ch => ch.charCodeAt(0)));

export const jsonToText = (json: JSONObject): string =>
  JSON.stringify(json, null, 4 );
export const textToJson = (text: string): JSONObject => JSON.parse(text)
export const textToMinifiedJson = (text: string): string => JSON.stringify(JSON.parse(text))
export const getJsonBytesSize = (json: JSONObject): number =>
  new TextEncoder().encode(textToMinifiedJson(JSON.stringify(json))).length
export const downloadFile = (content: BlobPart, filename: string = 'file', type = JSONLD_MIME_TYPE) => {
  const blob = new Blob([content], {
    type: type,
  });

  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(a.href);
};

// If the @content is an object this function won't trigger
export const documentLoader = async (url: string) => {
  try {
    const document = await fetch(url)
      .then((response) => response.json())
    // Overwrite marker that had to be previously set because this function may or may not trigger
    performance.mark(markerFrom)
    return {
      contextUrl: null,
      document,
      documentUrl: url
    };
  } catch (e) {
    throw new Error(`Refused to load URL "${url}".`);
  }
};
